import { render, staticRenderFns } from "./MessageBook.vue?vue&type=template&id=562c9edc&scoped=true&"
import script from "./MessageBook.vue?vue&type=script&lang=js&"
export * from "./MessageBook.vue?vue&type=script&lang=js&"
import style0 from "./MessageBook.vue?vue&type=style&index=0&id=562c9edc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562c9edc",
  null
  
)

export default component.exports